module.exports = __webpack_public_path__ + "static/media/tow_truck_selected.3727b7aa.svg";